module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEZJREFUeNpi/P///w0GBgZ1BsrBLRYgsZpKht1kGAUDCxiBSWMlkFamgll3mEbDc5gljSYgrUEFs26ADAPldjVqlBoAAQYAP08UheeRFwUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.png
// module id = E2RZ
// module chunks = 1